import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  viewBox: "0 0 16 16",
  fill: "none"
}
const _hoisted_2 = { "clip-path": "url(#clip0_455_292)" }
const _hoisted_3 = ["stroke"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        d: "M3.33301 7.99999L6.66634 11.3333L13.333 4.66666",
        stroke: $props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, _hoisted_3)
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_455_292" }, [
        _createElementVNode("rect", {
          width: "16",
          height: "16",
          fill: "white"
        })
      ])
    ], -1))
  ]))
}